import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api, staffToken } from '../../lib/api';
import Logo from '../../components/Logo';

const MESSAGES = {
  invalidCredentials: 'That email and password don\'t match an active staff account.',
  accountSuspended: 'This account has been suspended.',
  tooManyLoginAttempts: 'Too many unsuccessful attempts. Please wait 15 minutes and try again.',
};

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(location.state && location.state.expired ? 'Your session ended. Please sign in again.' : '');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const res = await api('/auth/login', { method: 'POST', body: { email, password } });
      staffToken.set(res.data.token);
      navigate((location.state && location.state.from) || '/staff/contracts', { replace: true });
    } catch (err) {
      setError(MESSAGES[err.code] || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream px-4">
      <form onSubmit={submit} className="wc-card w-full max-w-sm p-7">
        <Logo className="h-10 mb-3" />
        <h1 className="mt-1 text-xl font-bold">Staff sign-in</h1>
        <label className="wc-label mt-6" htmlFor="email">Email</label>
        <input id="email" type="email" className="wc-input" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required />
        <label className="wc-label mt-4" htmlFor="password">Password</label>
        <input id="password" type="password" className="wc-input" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
        {error && <p className="mt-4 rounded-lg bg-danger-soft p-3 text-sm text-danger">{error}</p>}
        <button type="submit" className="wc-btn-primary mt-6 w-full" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
      </form>
    </div>
  );
};

export default Login;
